const Form_showUSPrivacyPolicy = require("./Form_showUSPrivacyPolicy");
const Form_showUKPrivacyPolicy = require("./Form_showUKPrivacyPolicy");
const Form_showEMEAPrivacyPolicy = require("./Form_showEMEAPrivacyPolicy");

/**
 * @param countrySelect {HTMLSelectElement}
 * @return {void}
 */
module.exports = function When_CountrySelect_changes(countrySelect) {
    const country = countrySelect.value;

    const form = countrySelect.closest("form");

    if (form instanceof HTMLFormElement) {
        if (country === "United States") {
            Form_showUSPrivacyPolicy(form);
        } else if (country === "United Kingdom") {
            Form_showUKPrivacyPolicy(form);
        } else {
            Form_showEMEAPrivacyPolicy(form);
        }
    }
}